import classNames from "classnames";
import { useTranslation } from "features/translations";
import { Action, Icon, Paragraph } from "shared/components";

import { useWidgetContent } from "../Content064.context";
import styles from "./ButtonAdd.module.scss";

export const ButtonAdd = ({ label, className }) => {
  const { t } = useTranslation();
  const { isAddingDisabled, onOpen } = useWidgetContent();

  return (
    <Action
      className={classNames(styles.button, className)}
      onClick={onOpen}
      disabled={isAddingDisabled}
    >
      <Paragraph className={styles.label} color="brand" appearance="bigger">
        {label || t("add_program")}
      </Paragraph>
      <div className={styles.circle}>
        <Icon name="plus" className={styles.icon} />
      </div>
    </Action>
  );
};
